import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
export function WhySoCheap() {
  return <section className="py-20 px-4 bg-primary-contrast" data-id="element-233">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 sm:p-12 shadow-lg border border-text-primary/5 relative" data-id="element-234">
        <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-accent text-white p-3 rounded-full shadow-lg" data-id="element-235">
          <HelpCircle size={32} data-id="element-236" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-6" data-id="element-237">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-text-primary mb-6" data-id="element-238">
            ¿Por qué cuesta tan poco?
          </h2>

          <div className="space-y-6 text-lg text-text-primary/80 text-left" data-id="element-239">
            <p data-id="element-240">
              Si has leído hasta aquí, probablemente te estés preguntando:{' '}
              <span className="italic" data-id="element-241">
                "Si este protocolo es tan bueno, ¿por qué lo regalan por solo
                $6.36?"
              </span>
            </p>
            <p data-id="element-242">
              La respuesta es simple y transparente:{' '}
              <strong data-id="element-243">Estamos en etapa de lanzamiento.</strong>
            </p>
            <p data-id="element-244">
              Queremos eliminar la excusa del precio. Sabemos que has gastado
              cientos de dólares en suplementos, dietas y consultas que no te
              dieron resultados porque no estaban adaptados a esta etapa
              específica de tu vida.
            </p>
            <p data-id="element-245">
              Nuestra meta es que miles de mujeres prueben{' '}
              <span className="font-bold text-text-primary" data-id="element-246">
                PERI-MENOPAUSIA REBELDE
              </span>{' '}
              ahora, obtengan resultados increíbles y nos envíen sus
              testimonios.
            </p>
            <div className="bg-accent/10 p-6 rounded-2xl border border-accent/20 mt-8" data-id="element-247">
              <p className="font-bold text-text-primary text-center" data-id="element-248">
                ⚠️ Advertencia: Una vez que alcancemos nuestra meta de casos de
                éxito iniciales, el precio subirá a su valor normal de $49.99.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}